export default "__VITE_ASSET__BOsc0Kzu__"